import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { withReportsHistory } from './../../../shared/containers/containerReportsHistory'
import { withReportTime } from './../../../shared/containers/containerReportTime'
import { withReportData } from '../../../shared/containers/containerReportData'
import { withSelectedCars } from '../../../shared/containers/containerSelectedCars'
import { withSelectedReports } from '../../../shared/containers/containerSelectedReports'
import { withReport } from '../../../shared/containers/containerReport'
import { withReportCar } from '../../../shared/containers/containerReportCar'
import { withReportFields } from '../../../shared/containers/containerReportFields'
import { withUnitReport } from '../../../shared/containers/containerUnitReport'

import { CANCEL_MESSAGE } from '../../../shared/services/cancelRequest.service'
import { states } from '../../../reducers/queriesStates'

class HistoryReportItemWrapper extends Component {
  componentDidMount() {
    const {
      data,
      onChangeTimeReport,
      onSelectReport,
      onChangeSelectedCar,
      onСhangeReport,
      onChangeReportCar,
      onRequestReportData,
      reportDataState,
      onSetHistoryReportReady,
      onSetReportDataNotRequested,
      reportFieldsDataState,
      cancelReportFields,
      unitReportDataState,
      cancelUnitReport
    } = this.props
    const { cars, reports, reportStartDate, reportEndDate } = data

    onChangeTimeReport(
      ['reportStartDate', 'reportStartTime', 'reportEndDate', 'reportEndTime'],
      [new Date(reportStartDate), new Date(reportStartDate), new Date(reportEndDate), new Date(reportEndDate)]
    )
    onSelectReport(reports)
    onChangeSelectedCar(cars)
    onСhangeReport(reports[0].title, reports[0].id, reports[0].reportType)
    onChangeReportCar(cars[0].id)
    onSetHistoryReportReady()

    if (reportDataState === states.REQUEST) {
      if (reportFieldsDataState === states.REQUEST) {
        cancelReportFields.cancel(CANCEL_MESSAGE)
      } else if (unitReportDataState === states.REQUEST) {
        cancelUnitReport.cancel(CANCEL_MESSAGE)
      } else {
        onSetReportDataNotRequested()
      }
    } else {
      onRequestReportData(reportStartDate, reportEndDate)
    }
  }

  componentDidUpdate(prevProps) {
    const { 
      reportDataState, 
      onRequestReportData, 
      reportStartDate, 
      reportEndDate, 
      onSetReportDataNotRequested, 
      isReportFieldsCanceled,
      isUnitReportCanceled 
    } = this.props

    if (reportDataState === states.REQUEST && prevProps.reportDataState !== states.REQUEST) {
      this.props.history.push('/reports/')
    }

    if (reportDataState === states.NOT_REQUESTED && prevProps.reportDataState === states.REQUEST) {
      onRequestReportData(reportStartDate, reportEndDate)
    }

    if (isReportFieldsCanceled !== prevProps.isReportFieldsCanceled && isReportFieldsCanceled && reportDataState === states.REQUEST) {
      onSetReportDataNotRequested()
    }

    if (isUnitReportCanceled !== prevProps.isUnitReportCanceled && isUnitReportCanceled && reportDataState === states.REQUEST) {
      onSetReportDataNotRequested()
    }
  }

  render() {
    return (
      this.props.children
    )
  }
}

export default withUnitReport(withReportFields(withRouter(withReportCar(withReport(withReportsHistory(withSelectedReports(withSelectedCars(withReportData(withReportTime(HistoryReportItemWrapper))))))))))